import { Resolve } from '../Contract';
var InjectMember = (function () {
    function InjectMember(constructor, resolve) {
        this.myConstructor = constructor;
        this.resolve = resolve;
    }
    InjectMember.prototype.getObject = function (inject) {
        if (this.resolve === Resolve.Singleton) {
            if (this.instance === undefined) {
                this.instance = new this.myConstructor(inject);
            }
            return this.instance;
        }
        return new this.myConstructor(inject);
    };
    return InjectMember;
}());
export { InjectMember };
